import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ru } from './ru';
import { en } from './en';

const savedLanguage = localStorage.getItem('exchange-storage');
const defaultLanguage = savedLanguage
  ? JSON.parse(savedLanguage).state?.language || 'ru'
  : 'ru';

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
  },
  lng: defaultLanguage,
  fallbackLng: 'ru',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
